import React from 'react';
import { RouteProp, useRoute } from '@react-navigation/native';
import { CamerasParamList } from '../../../typings/Params';
import { RootNavigation } from '../../../Routes';
import CameraPlayerComponent from './CameraPlayerComponent';

interface EventDetailParams {
    navigation: RootNavigation;
}

export default function CameraPlayer({ navigation }: EventDetailParams) {
    const route = useRoute<RouteProp<CamerasParamList, 'CameraPlayer'>>();
    return <CameraPlayerComponent navigation={navigation} route={route} page={'watch'} />;
}
